export var GameUpdate = /*#__PURE__*/ function(GameUpdate) {
    GameUpdate[GameUpdate["FirstGameState"] = 1] = "FirstGameState";
    // KickedFromGame = 3,
    GameUpdate[GameUpdate["BuildGame"] = 4] = "BuildGame";
    GameUpdate[GameUpdate["TogglePauseGame"] = 5] = "TogglePauseGame";
    GameUpdate[GameUpdate["CanResignGame"] = 6] = "CanResignGame";
    // ChatGameLog = 7,
    // InitialPlacement = 8,
    // CurrentGameState = 9,
    // BankState = 10,
    // DiceState = 11,
    GameUpdate[GameUpdate["PlayerControllerState"] = 12] = "PlayerControllerState";
    GameUpdate[GameUpdate["AmountOfCardsToDiscard"] = 13] = "AmountOfCardsToDiscard";
    // MapState = 14,
    // MapEdges = 15,
    // MapCorners = 16,
    // MapTiles = 17,
    GameUpdate[GameUpdate["CardsToSelectForDevelopmentCard"] = 18] = "CardsToSelectForDevelopmentCard";
    GameUpdate[GameUpdate["CardsToSelectForPendingTransaction"] = 19] = "CardsToSelectForPendingTransaction";
    GameUpdate[GameUpdate["SelectPlayerUsingDevelopmentCard"] = 20] = "SelectPlayerUsingDevelopmentCard";
    GameUpdate[GameUpdate["ConfirmUseDevelopmentCard"] = 21] = "ConfirmUseDevelopmentCard";
    GameUpdate[GameUpdate["StealDevelopmentCardFromPlayer"] = 22] = "StealDevelopmentCardFromPlayer";
    GameUpdate[GameUpdate["StealResourceCardFromPlayer"] = 23] = "StealResourceCardFromPlayer";
    GameUpdate[GameUpdate["SelectPlayerAndCard"] = 24] = "SelectPlayerAndCard";
    GameUpdate[GameUpdate["SelectCardsToGiveToPlayer"] = 25] = "SelectCardsToGiveToPlayer";
    GameUpdate[GameUpdate["SelectDice"] = 26] = "SelectDice";
    GameUpdate[GameUpdate["ClosePopupUI"] = 27] = "ClosePopupUI";
    GameUpdate[GameUpdate["GivePlayerResourcesFromTile"] = 28] = "GivePlayerResourcesFromTile";
    GameUpdate[GameUpdate["SelectPlayer"] = 29] = "SelectPlayer";
    GameUpdate[GameUpdate["HighlightCorners"] = 30] = "HighlightCorners";
    GameUpdate[GameUpdate["HighlightRoadEdges"] = 31] = "HighlightRoadEdges";
    GameUpdate[GameUpdate["HighlightShipEdges"] = 32] = "HighlightShipEdges";
    GameUpdate[GameUpdate["HighlightTiles"] = 33] = "HighlightTiles";
    GameUpdate[GameUpdate["HighlightDiceNumbersForInventor"] = 34] = "HighlightDiceNumbersForInventor";
    // BankTradeRatioState = 35,
    GameUpdate[GameUpdate["TradeState"] = 36] = "TradeState";
    GameUpdate[GameUpdate["TradeResponseState"] = 37] = "TradeResponseState";
    GameUpdate[GameUpdate["EmbargoState"] = 38] = "EmbargoState";
    GameUpdate[GameUpdate["BoldTextInTradeWindow"] = 39] = "BoldTextInTradeWindow";
    GameUpdate[GameUpdate["CloseOffer"] = 40] = "CloseOffer";
    // OfferError = 41,
    GameUpdate[GameUpdate["InfoMessage"] = 42] = "InfoMessage";
    GameUpdate[GameUpdate["ExchangeCards"] = 43] = "ExchangeCards";
    GameUpdate[GameUpdate["GameSettings"] = 44] = "GameSettings";
    GameUpdate[GameUpdate["GameEndState"] = 45] = "GameEndState";
    GameUpdate[GameUpdate["RematchLink"] = 46] = "RematchLink";
    GameUpdate[GameUpdate["EndGameText"] = 47] = "EndGameText";
    GameUpdate[GameUpdate["SpectatorData"] = 48] = "SpectatorData";
    // PlayersCanceledSpecialBuildPhase = 49,
    // SpecialBuildPhaseLastPlayerToRollDice = 50,
    GameUpdate[GameUpdate["Vote"] = 51] = "Vote";
    GameUpdate[GameUpdate["CityImprovementStateUpdated"] = 52] = "CityImprovementStateUpdated";
    GameUpdate[GameUpdate["ForceShowCityImprovementButtons"] = 53] = "ForceShowCityImprovementButtons";
    // UnlockedCityImprovement = 54,
    // PlayerReceivedMetropolis = 55,
    // KnightPieceStateUpdated = 56,
    // BarbarianStateUpdated = 57,
    GameUpdate[GameUpdate["MerchantStateUpdates"] = 58] = "MerchantStateUpdates";
    GameUpdate[GameUpdate["PlayTurnSound"] = 59] = "PlayTurnSound";
    GameUpdate[GameUpdate["PlayersTakingAction"] = 60] = "PlayersTakingAction";
    GameUpdate[GameUpdate["PlayersDoneTakingAction"] = 61] = "PlayersDoneTakingAction";
    GameUpdate[GameUpdate["ExitInitialPlacement"] = 62] = "ExitInitialPlacement";
    GameUpdate[GameUpdate["TradeFinalized"] = 63] = "TradeFinalized";
    GameUpdate[GameUpdate["TradeRejectedByAll"] = 64] = "TradeRejectedByAll";
    GameUpdate[GameUpdate["KnightPlaced"] = 65] = "KnightPlaced";
    GameUpdate[GameUpdate["KnightActivated"] = 66] = "KnightActivated";
    GameUpdate[GameUpdate["KnightUpgraded"] = 67] = "KnightUpgraded";
    GameUpdate[GameUpdate["PlayerDisconnected"] = 68] = "PlayerDisconnected";
    GameUpdate[GameUpdate["PlayerReconnected"] = 69] = "PlayerReconnected";
    GameUpdate[GameUpdate["DiscardBroadcast"] = 70] = "DiscardBroadcast";
    // PlayCityImprovementSound = 71,
    // PlayAchievementCKProgressSound = 72,
    GameUpdate[GameUpdate["SpectatorChatMessage"] = 73] = "SpectatorChatMessage";
    GameUpdate[GameUpdate["SendBroadcast"] = 74] = "SendBroadcast";
    GameUpdate[GameUpdate["TradeEmbargoState"] = 75] = "TradeEmbargoState";
    GameUpdate[GameUpdate["Ping"] = 76] = "Ping";
    GameUpdate[GameUpdate["BeginnerHintActivated"] = 77] = "BeginnerHintActivated";
    GameUpdate[GameUpdate["KarmaState"] = 78] = "KarmaState";
    GameUpdate[GameUpdate["StressTestLagTest"] = 79] = "StressTestLagTest";
    GameUpdate[GameUpdate["ResetTradeStateAtEndOfTurn"] = 80] = "ResetTradeStateAtEndOfTurn";
    GameUpdate[GameUpdate["ClosedTradeStates"] = 81] = "ClosedTradeStates";
    // GivePlayerGrantedCards = 82,
    // TradePlayersCreatingCounterOfferState = 83,
    // GameInfo = 84,
    // ChatTextHistory = 85,
    // ChatGameLogHistory = 86,
    GameUpdate[GameUpdate["BeginnerModeActionUpdate"] = 87] = "BeginnerModeActionUpdate";
    GameUpdate[GameUpdate["BeginnerModeLevelEnd"] = 88] = "BeginnerModeLevelEnd";
    GameUpdate[GameUpdate["ResetBeginnerModeLevel"] = 89] = "ResetBeginnerModeLevel";
    GameUpdate[GameUpdate["TriggerClientGameStateReset"] = 90] = "TriggerClientGameStateReset";
    GameUpdate[GameUpdate["GameStateUpdated"] = 91] = "GameStateUpdated";
    GameUpdate[GameUpdate["ReplayData"] = 92] = "ReplayData";
    GameUpdate[GameUpdate["EndOfInitialPlacement"] = 93] = "EndOfInitialPlacement";
    GameUpdate[GameUpdate["RushInitialPlacementTimedOutAnalytic"] = 94] = "RushInitialPlacementTimedOutAnalytic";
    return GameUpdate;
}({});
